module.exports = __webpack_public_path__ + "img/user-crown.58dac2ca.svg";